export const getFormattedStatus = (status) => {
    const statusMap = {
      shortlisted: "Shortlisted",
      not_shortlisted: "Not Shortlisted",
      interviewed: "Interviewed",
      selected: "Selected",
      rejected: "Rejected",
      hold: "Hold",
      onboarded: "Onboarded",
      working: "Working",
      left: "Left",
      not_joined: "Not Joined",
      project_success: "Project Success",
      not_screened: "Not Screened",
      screened: "Screened",
      in_progress: "In Progress",
      rejected_from_interview: "Rejected From Interview",
      not_working: "Not Working",
      active: "Active",
      inactive: "Inactive",
      screening: "Screening",
    };

    return statusMap[status?.toLowerCase()] || status;
  };